import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class StampDateTimeHelper {
    getCorrectDateTimeFormatForTheSignatureField(): string {
        let currentDateTime: Date = new Date();
        let dateTimeString: string = "";

        dateTimeString = formatDate(currentDateTime, "dd-MM-y HH:mm zzzz", "en-US");
        let formattedDateTimeString = dateTimeString.replace("GMT", "");

        return formattedDateTimeString;
      }
}